<template>
  <!-- 银行卡管理 -->
  <div>
    <div class="bg_gray"></div>
    <!--  -->
    <div class="banklist">
      <headbox title="银行卡管理" bgColor="#fff" isborder="true"></headbox>
      <div class="bankbox" v-for="items in banklist" :key="items.id">
        <p class="titlebank">{{ items.bank }}</p>
        <p class="bankmunber">{{ items.num | BankOnlyFour }}</p>
      </div>
    </div>

    <div class="martop">
      如需修改银行卡账号,请拨打客服电话<b>4001 - 886 - 722</b>
    </div>
  </div>
</template>
<script>
import headbox from "@/components/head.vue";
import { getCard } from "@/utils/api";
import { BankOnlyFour } from "@/utils/filters";
export default {
  data() {
    return {
      banklist: []
    };
  },
  components: {
    headbox
  },
  filters: {
    BankOnlyFour
  },
  mounted() {
    getCard().then(res => {
      console.log("res:" + res);
      if (res) {
        this.banklist = res;
      } else {
        this.$toast.fail(res.msg || "网络错误,请稍后再试");
      }
    });
  }
};
</script>
<style lang="scss" scoped="true">
.bg_gray {
  background: #f5f5f5;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
}
.banklist {
  position: relative;
  z-index: 2;
}
.martop {
  margin-top: 150px;
  text-align: center;
  position: relative;
  z-index: 2;
  color: #999999;
  font-size: 32px;
  b {
    margin-top: 15px;
    display: block;
    color: #ffb606;
    font-size: 36px;
    font-weight: normal;
  }
}
.bankbox {
  font-size: 44px;
  color: rgba(255, 255, 255, 1);
  line-height: 28px;
  width: 670px;
  height: 220px;
  padding-left: 50px;
  background: linear-gradient(
    -30deg,
    rgba(255, 185, 64, 1),
    rgba(251, 172, 30, 1)
  );
  box-shadow: 0px 8px 20px 0px rgba(76, 74, 72, 0.12);
  border-radius: 20px;
  margin: 40px auto;
  .titlebank {
    padding-top: 60px;
    font-size: 32px !important;
    margin-bottom: 40px;
  }
  .bankmunber {
    font-size: 44px;
  }
}
</style>
